import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function login( userInfo) {
    const request = axios.post(urls.LOGIN_URL , userInfo, {
    headers: {
      "Content-Type": "application/json"
    }
  });
  return { type: ActionTypes.LOGIN, payload: request };
}

export function loginWithToken(sessionToken) {
    const request = axios.post(
        urls.LOGIN_WITH_TOKEN_URL,   // no query string
        {}, // raw string as JSON body JSON.stringify(sessionToken)
        {
            headers: {
                Authorization: sessionToken,  // init session by token, no need to login again and re create session
                "Content-Type": "application/json"
            }
        }
    );

    return { type: ActionTypes.Login_With_Token, payload: request };
}

export function register(userInfo, referralCode) {
    //userInfo.regionId = userInfo.region.id;
   // userInfo.title = userInfo.title.id;

    // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
    userInfo.culture = userInfo.locale;

    const request = axios.post(urls.REGISTER_URL, userInfo, {
        headers: (referralCode) ? {
            "Content-Type": "application/json",
            "referralCode": `${referralCode}`,
        } : {"Content-Type": "application/json"}
    });
    return { type: ActionTypes.REGISTER, payload: request };
}

export function checkExists(userInfo, referralCode) {
    const request = axios.post(urls.CHECK_CUSTOMER_EXISTS_URL, userInfo, {
        headers: (referralCode) ? {
            "Content-Type": "application/json",
            "referralCode": `${referralCode}`,
        } : {"Content-Type": "application/json"}
    });
    return { type: ActionTypes.CHECK_CUSTOMER_EXISTS, payload: request };
}

export function resetExistsCheck(userInfo) {
    return { type: ActionTypes.RESET_CHECK_CUSTOMER_EXISTS, payload: false };
}


export function saveGuestProfile(newLocale) {
    return {
        type: ActionTypes.SAVE_GUEST_PROFILE, payload: newLocale };
}

export function saveProfile(userInfo) {
   // userInfo.regionId = userInfo.region.id;
   // userInfo.title = userInfo.title.id;

   // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
   userInfo.culture = userInfo.locale;
   
    const request = axios.post(urls.SAVE_PROFILE_URL, userInfo, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return { type: ActionTypes.SAVE_PROFILE, payload: request };
}
export function getCustomer(customerId) {
    const request = axios.post(
        `${urls.GET_CUSTOMER_URL}?customerId=${customerId}`,
        {},
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    );

    return { type: ActionTypes.GET_CUSTOMER, payload: request };
}

export function logout(user) {
  const request = axios.post(
    urls.LOGOUT_URL,
    {},
    {
      headers: {
        //Authorization: user.accessToken,
        "Content-Type": "application/json"
      }
    }
  );
  return { type: ActionTypes.LOGOUT, payload: request };
}
export function forgotPassword(username) {
    const request = axios.post(urls.FORGOT_PASSWORD_URL, username, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return { type: ActionTypes.FORGOT_PASSWORD, payload: request };
}


export function checkSession(user) {
  const request = axios.get(
    urls.CHECK_SESSION_URL,
    {},
    {
      headers: {
        //Authorization: user.accessToken,//`Bearer ${user.accessToken}`
        "Content-Type": "application/json"
      }
    }
  );
  return { type: ActionTypes.CHECK_SESSION, payload: request };
}

export function subscribeToNewsletter(subscriber) {
// Api for simple strings require data in this formate = =email
   //var data = `=${payload.email}`;
    const request = axios.post(urls.NEWSLETTER_SUBSCRIBE_URL, subscriber, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return { type: ActionTypes.NEWSLETTER_SUBSCRIBE, payload: request };
}




// export function getUserInformation(props) {
//   const request = axios.post(urls.ACCOUNT_INFO_URL, props);
//   return { type: ActionTypes.GET_USER_INFO, payload: request };
// }
